import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { JOB_KINDS, JOB_SORTABLE, JOB_STATES } from '../vocabulary'
import { jobQuery, jobsQuery } from './queries'

const jobsSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, JOB_SORTABLE, [], [], {
    kind: JOB_KINDS,
    state: JOB_STATES,
  })

export const jobsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('jobs'),
  path: '/jobs',
  validateSearch: jobsSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(jobsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'JobsPage'),
})

export const jobRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('jobs'),
  path: '/jobs/$id',
  validateSearch: jobsSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(jobQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'JobPage'),
})

export const jobRoutes = [jobsRoute, jobRoute]
